module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01-m-en.5fcc66e55c68723f32d19c66cc7d8c92.png";